<template>
  <div class="row">
      <div class="col-12">
          <div class="row">
              <div class="col-sm-12 col-md-9">
                  <h3 class="mb-0">Dealers</h3>
              </div>
              <div class="col-sm-12 col-md-3 text-right">
                  <div class="form-group">
                      <div class="input-group search-field">
                          <input
                              class="form-control"
                              type="text"
                              placeholder="Search Dealers"
                              v-model="searchTerm"
                              autocomplete="off"
                              @input="handleSearch()"
                          />
                          <div class="input-group-prepend">
                              <span class="input-group-text"
                                  ><i class="fas fa-search"></i
                              ></span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <br />
          <Bootstrap4Pagination
              :data="paginatedAllLocations"
              @pagination-change-page="getResults"
              :align="'right'"
              :limit="1"
              :keepLength="true"
          >
              <template #prev-nav>
                  <i class="fa fa-arrow-left"></i> PREVIOUS</template
              >
              <template #next-nav>
                  NEXT <i class="fa fa-arrow-right"></i>
              </template>
          </Bootstrap4Pagination>
          <table
              class="table table-responsive table-striped border-bottom mt-2"
          >
              <thead class="thead-light">
                  <tr>
                      <th>Name</th>
                      <th>Address</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Zip Code</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Sales Rep</th>
                      <!-- <th>Direct to Dealer</th> -->
                      <th>SPEQ Status</th>
                      <th style="width: 8em"></th>
                  </tr>
              </thead>
              <tbody>
                  <template v-for="loc in paginatedAllLocations.data" :key="loc.id">
                      <tr>
                          <td>{{ loc.name }}</td>
                          <td>{{ loc.address }}</td>
                          <td>{{ loc.city }}</td>
                          <td>{{ loc.state }}</td>
                          <td>{{ loc.zip_code }}</td>
                          <td>{{ loc.email }}</td>
                          <td>{{ loc.phone }}</td>
                          <td>{{ loc.sales_rep?.name }}</td>
                          <!-- <td>
                              {{
                                  loc.direct_to_dealer_onboarding
                                      ?.document_file_path != null
                                      ? "Yes"
                                      : "No"
                              }}
                          </td> -->
                          <td>
                              <span
                                  v-if="loc.is_speq === 1"
                                  class="badge badge-success"
                              >
                                  Enrolled
                              </span>
                              <span
                                  class="badge badge-primary"
                                  v-else-if="loc.speq_invite_status === 1"
                              >
                                  Invited
                              </span>
                              <span
                                  class="badge badge-warning"
                                  v-else-if="loc.speq_invite_status === 2"
                              >
                                  Pending
                              </span>
                              <span
                                  class="badge badge-declined"
                                  v-else-if="loc.speq_invite_status === 4"
                              >
                                  Declined
                              </span>
                              <template v-else>
                                  <span class="badge badge-secondary">
                                      N/A
                                  </span>
                                  <span class="ml-3 view-action" @click="sendSpeqInvite(loc)" v-if="authUser.speq_invite_access">
                                      INVITE?
                                  </span>
                              </template>
                          </td>
                          <td>
                              <span
                                  class="px-1 view-action"
                                  @click="viewDealer(loc)"
                                  ><i
                                      class="fa fa-eye"
                                      aria-hidden="true"
                                  ></i>
                                  VIEW</span
                              >
                          </td>
                      </tr>
                  </template>
              </tbody>
          </table>
          <Bootstrap4Pagination
              :data="paginatedAllLocations"
              @pagination-change-page="getResults"
              :align="'right'"
              :limit="1"
              :keepLength="true"
          >
              <template #prev-nav>
                  <i class="fa fa-arrow-left"></i> PREVIOUS</template
              >
              <template #next-nav>
                  NEXT <i class="fa fa-arrow-right"></i>
              </template>
          </Bootstrap4Pagination>

          <!-- Pagination -->
          <!-- <table-pagination
              v-model="paginatedLocations"
              :all-rows="searchAllLocationsbyTerm"
              :perPage="perPage"
              :dealer="true"
              @updateRow="updateRow"
              @updateCurrPage="updateCurrPage"
          >
          </table-pagination> -->
      </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import TablePagination from "@/components/TablePagination.vue";
import { Bootstrap4Pagination } from "laravel-vue-pagination";

export default {
  props: [],
  emits: [],
  components: {
      TablePagination,
      Bootstrap4Pagination
  },
  setup() {
      const store = useStore();

      let authUser = computed(function () {
          return store.state.user;
      });

      // let allLocations = computed(function () {
      //     return store.state.allLocations;
      // });

      let dealerCurrPage = computed(function () {
          return store.state.dealerCurrPage;
      });

      function setLocationInfo(location) {
          store.commit("setLocationInfo", location);
      }

      onMounted(() => {});

      return {
          authUser,
          store,
          dealerCurrPage,
          setLocationInfo,
      };
  },
  data() {
      return {
          paginatedAllLocations: [],
          perPage: 100,
          isLoading: false,
          searchTerm: "",
          currentPage: this.page ? this.page : 1,
      };
  },
  computed: {
      searchAllLocationsbyTerm() {
          if (this.searchTerm === "") {
              return this.allLocations;
          }

          return this.allLocations.filter((loc) => {
              if (
                  (loc.name !== null &&
                      loc.name
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase())) ||
                  (loc.address !== null &&
                      loc.address
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase())) ||
                  (loc.city !== null &&
                      loc.city
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase())) ||
                  (loc.state !== null &&
                      loc.state
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase())) ||
                  (loc.zip_code !== null &&
                      loc.zip_code
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase())) ||
                  (loc.sales_rep !== null &&
                      loc.sales_rep.name
                          .toLowerCase()
                          .includes(this.searchTerm.toLowerCase()))
              ) {
                  return loc;
              }
          });
      },
  },
  mounted() {
      localStorage.setItem("currPage", 1);
      // this.store.dispatch("getAllLocations");
      this.getResults();
  },
  methods: {
      updateRow(val) {
          this.paginatedLocations = val;
      },
      updateCurrPage(val) {
          localStorage.setItem("currPage", val);
      },
      viewDealer(location) {
          this.setLocationInfo(location);
          this.$router.push({
              name: "speqDealerInfo",
              params: { id: location.id },
          });
      },
      sendSpeqInvite(location) {
          this.store.dispatch("sendSpeqInvite", location.id).then(resp => {
              this.store.dispatch("getAllLocations");
          });
      },
      getResults(page = 1) {
          let searchTerm = this.searchTerm;
          axios
              .get(
                  "/api/get-all-locations-paginated?page=" +
                      page +
                      "&search=" +
                      searchTerm
              )
              .then((res) => {
                  this.paginatedAllLocations = res.data;
              })
              .catch((err) => {});
      },
      handleSearch() {
          if (this.debouncedFunction) {
              clearTimeout(this.debouncedFunction);
          }
          this.debouncedFunction = setTimeout(() => {
              this.getResults(1);
          }, 500);
      },
  },
};
</script>
